// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeader_header__2Slqf"};